import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import bankIcon from '../assets/images/settings/bank.png';
import outletIcon from '../assets/images/settings/outlet.png';
import designationIcon from '../assets/images/settings/designation.png';
import userIcon from '../assets/images/settings/user.png';
import shiftIcon from '../assets/images/settings/shift.svg';
import documentsIcon from '../assets/images/settings/documents.svg';
import rolesIcon from '../assets/images/settings/roles.svg';
import { hasModulePermission } from '../utils/permissions';

const Settings = () => {
    const navigate = useNavigate();

    const menuItems = [
        { path: 'bank', icon: bankIcon, title: 'Bank', moduleKey: 'settings-bank' },
        { path: 'users', icon: userIcon, title: 'User', moduleKey: 'settings-user' },
        { path: 'outlet', icon: outletIcon, title: 'Outlet Name', moduleKey: 'settings-outlet' },
        { path: 'designation', icon: designationIcon, title: 'Designation', moduleKey: 'settings-designation' },
        { path: 'shifts', icon: shiftIcon, title: 'Shift Management', moduleKey: 'settings-shift' },
        { path: 'documents', icon: documentsIcon, title: 'Documents', moduleKey: 'settings-document' },
        { path: 'uniform-types', icon: documentsIcon, title: 'Uniform Type', moduleKey: 'settings-uniform-type' },
        { path: 'roles', icon: rolesIcon, title: 'Roles & Permissions', moduleKey: 'role_management' }
    ];

    const visibleMenuItems = menuItems.filter((item) => hasModulePermission(item.moduleKey, 'view'));

    return (
        <DashboardLayout>
            <div className="container py-5">
                <div className='m-3'>
                    <div className="row g-0 col-md-8 border rounded">
                        {visibleMenuItems.length === 0 ? (
                            <div className="col-12 p-4 text-center text-muted">No settings modules assigned to your role.</div>
                        ) : visibleMenuItems.map((item, index) => {
                            const isOddCount = visibleMenuItems.length % 2 !== 0;
                            const isLastItem = index === visibleMenuItems.length - 1;
                            const isSingleInLastRow = isOddCount && isLastItem;
                            const itemsInLastRow = isOddCount ? 1 : 2;
                            const lastRowStartIndex = visibleMenuItems.length - itemsInLastRow;
                            const showRightBorder = index % 2 === 0 && !isSingleInLastRow;
                            const showBottomBorder = index < lastRowStartIndex;

                            return (
                                <div
                                    key={item.path}
                                    className="col-md-6 cursor-pointer"
                                    onClick={() => navigate(`/settings/${item.path}`)}
                                >
                                    <div className={`position-relative h-100 ${
                                        showRightBorder ? 'border-end' : ''
                                    } ${showBottomBorder ? 'border-bottom' : ''}`}
                                        style={{
                                            borderColor: '#dee2e6',
                                            borderWidth: '1px'
                                        }}>
                                        <div className="p-4">
                                            <h5 className="text-center mb-4">{item.title}</h5>
                                            <div className="text-center">
                                                <img
                                                    src={item.icon}
                                                    alt={item.title}
                                                    className="img-fluid"
                                                    style={{
                                                        height: '120px',
                                                        objectFit: 'contain'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default Settings;
